import fetchAPI from 'shared/fetchAPI'

export default function (key, value) {
  return fetchAPI(`/api/v3/creators/properties`, {
    method: 'PATCH',
    body: { [key]: value },
  })
}
